import React from 'react';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import UserService from '#/services/UserService';
import { SpinnerView } from './parts/SpinnerView';

function Login() {
  const navigate = useNavigate();
  const service = new UserService();
  const { control, handleSubmit, reset, formState } = useForm();

  const onSubmit = (values: any) => {
    service
      .signIn(values.email, values.password)
      .then((_) => {
        navigate('/');
      })
      .finally(() => reset());
  };

  return (
    <Container
      fluid
      className="h-100 mt-4 justify-content-center align-items-center w-50"
    >
      <Row>
        <Col>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group className="mb-3">
              <Form.Label>メールアドレス</Form.Label>
              <Controller
                control={control}
                name="email"
                render={({ field: { onChange, value, ref } }) => (
                  <Form.Control
                    type="email"
                    placeholder="メールアドレス"
                    onChange={onChange}
                    value={value}
                    ref={ref}
                  />
                )}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>パスワード</Form.Label>
              <Controller
                control={control}
                name="password"
                render={({ field: { onChange, value, ref } }) => (
                  <Form.Control
                    type="password"
                    placeholder="パスワード"
                    onChange={onChange}
                    value={value}
                    ref={ref}
                  />
                )}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Controller
                control={control}
                name="password"
                render={({ field: { onChange, value, ref } }) => (
                  <Form.Check type="checkbox" label="ログイン状態を保持する" />
                )}
              />
            </Form.Group>
            <Form.Group className="mt-5 text-center mb-2">
              <Controller
                control={control}
                name="submit"
                render={({ field: { ref } }) => (
                  <Button
                    type="submit"
                    className="w-50"
                    disabled={formState.isSubmitted}
                  >
                    {formState.isSubmitted ? (
                      <SpinnerView size="sm" />
                    ) : (
                      'ログイン'
                    )}
                  </Button>
                )}
              />
            </Form.Group>
            <Form.Group className="mt-5 text-center mb-2">
              <Link to="/register">新規登録はこちら</Link>
            </Form.Group>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}

export default Login;
